












import { isMmz } from '@/app/core/utils'
import { Dialog } from 'vant'
import { Component, Vue, Emit, Inject } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const searchModule = namespace('search') //vuex

@Component({})
export default class SearchHistory extends Vue {
  //vuex 声明
  @searchModule.State searchRecords!: any[]
  @searchModule.Action clearSearchRecords!: () => void

  shareEarn = this.$route.query.shareEarn

  clearHistory() {
    Dialog.confirm({
      message: '确认删除全部历史记录',
    }).then(() => {
      this.clearSearchRecords()
    })
  }

  @Inject({ from: 'useHistoryEP', default: null }) useHistoryEP!: any
  useHistoryExposure(item: any) {
    const { keyword } = item
    return this.useHistoryEP && this.useHistoryEP({keyword: keyword})
  }
  @Emit('useHistory')
  useHistory(item: any) {
    const { keyword } = item
    const isMMz = isMmz()
    this.$router.push({ name: 'searchRes', query: { searchKey: keyword, refresh: 'no', cmd: 'share', sharetype: '0', shareEarn: this.shareEarn,  hzwMmz: isMMz ? '1' : '' } })
  }
}
